const PROD_API_URL = 'https://backend.xsignature.ruddypp.site';
const API_URL =
  process.env.REACT_APP_MEDIA_URL ||
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? PROD_API_URL : '');
/**
 * Mengubah path gambar relatif menjadi URL lengkap
 * @param {string} imagePath - Path gambar relatif atau URL lengkap
 * @returns {string} URL gambar lengkap
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return getPlaceholderUrl('No+Image');
  }
  
  // Jika sudah URL lengkap, kembalikan apa adanya
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Jika path relatif, tambahkan base URL
  // Make sure the path starts with a slash
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${API_URL}${normalizedPath}`;
};

/**
 * Mendapatkan URL placeholder dengan teks kustom
 * @param {string} text - Teks untuk placeholder
 * @param {number} width - Lebar gambar (default: 400)
 * @param {number} height - Tinggi gambar (default: 300)
 * @returns {string} URL placeholder
 */
export const getPlaceholderUrl = (text = 'No+Image', width = 400, height = 300) => {
  // Gunakan placeholder.com sebagai alternatif yang lebih reliabel
  return `https://via.placeholder.com/${width}x${height}?text=${text}`;
};

const imageUrlUtils = {
  getImageUrl,
  getPlaceholderUrl
};

export default imageUrlUtils;
